import RightArrowIcon from "./VectorrightArrow.png";
import DefaultImg from "./defaultImage.png";
import Profile from "./profile.svg";
import Logo from "./logo.svg";
import AlertIcon from "./alertIcon.svg";
import Cloud from "./cloud.png";
import EmailVerified from "./email-verified.svg";
import EmailFailed from "./email-failed.svg";
import Pdf from "./pdf.png";
import Announcement from "./announcement.svg";
import Banner from "./bannerMedanta.png";
import BannerTransparent from "./Banner-transparent.png";
import BihaarGovtLogo from "./bihaar-govt.jpg";
import BannerFull from "./banner-full.jpg";

import Logo2 from "./medanta-logo.svg";
import BihaarGovtLogo2 from "./ht-logo.svg";
import Banner2 from "./banner2.png";

const IMAGES = {
  Announcement,
  Banner,
  BannerTransparent,
  BihaarGovtLogo,
  RightArrowIcon,
  DefaultImg,
  Profile,
  Logo,
  AlertIcon,
  Cloud,
  EmailVerified,
  EmailFailed,
  Pdf,
  Logo2,
  BihaarGovtLogo2,
  Banner2,
  BannerFull
};

export default IMAGES;
